import { classifyWhatsappSendError } from '../../../domain/superadmin/whatsappSendErrors';
import { formatDateTime } from '../../../utils/formatters';

/** Traduz o erro cru da UAZAPI para uma mensagem acionável em português. */
export function whatsappSendErrorText(
    raw: string | null | undefined,
    fallback = 'Falha ao enviar WhatsApp de teste.'
): string {
    const failure = classifyWhatsappSendError(raw);

    switch (failure.kind) {
        case 'restricted':
            return failure.until
                ? `O WhatsApp restringiu esta instância para iniciar novas conversas até ${formatDateTime(failure.until)}. Envie para um contato que já tenha conversa aberta com o número.`
                : 'O WhatsApp restringiu temporariamente os envios desta instância. Envie para um contato que já tenha conversa aberta com o número.';
        case 'disconnected':
            return 'A sessão do WhatsApp caiu. Desconecte e conecte a instância novamente para ler o QR Code.';
        default:
            return failure.detail ?? fallback;
    }
}
